// import React, { useEffect, useState } from 'react';
// import Swal from '../librarianSwal';
// import { useAuth } from '../../Constant/Auth';
import { useActiveLibraryId } from '../../Constant/useActiveLibrary';
// import * as Constants from '../../Constant/constant';

// import {
//   getAnnouncementsByLibrary,
//   addAnnouncement,
//   updateAnnouncement,
//   deleteAnnouncement,
//   getErrorMessage
// } from '../../api/api';

// const AnnouncementList = () => {
//   const { user } = useAuth();
//   const libraryId = useActiveLibraryId();
//   const staffId = user?.id || user?.staff_id;

//   const [announcements, setAnnouncements] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [search, setSearch] = useState('');
//   const [showPreview, setShowPreview] = useState(false);
//   const [previewEdit, setPreviewEdit] = useState(false);
//   const [attachments, setAttachments] = useState([]);
//   // Object URLs for image attachments, keyed by array index (for live preview)
//   const [attachmentUrls, setAttachmentUrls] = useState([]);
//   // Id of the announcement being edited (null = creating a new one)
//   const [editingId, setEditingId] = useState(null);

//   const [formData, setFormData] = useState({
//     title: '',
//     message: '',
//     target_audience: ['all'],
//     publish_status: 'published',
//     publish_date: new Date().toISOString().slice(0, 10)
//   });

//   const AUDIENCE_OPTIONS = [
//     { value: 'all', label: 'All' },
//     { value: 'parents', label: 'Parents' },
//     { value: 'students', label: 'Students' },
//     { value: 'staff', label: 'Staff' }
//   ];

//   // Toggle an audience checkbox. "All" is exclusive of the others.
//   const toggleAudience = (value) => {
//     setFormData((prev) => {
//       const current = Array.isArray(prev.target_audience) ? prev.target_audience : [];

//       if (value === 'all') {
//         return { ...prev, target_audience: ['all'] };
//       }

//       let next = current.filter((v) => v !== 'all');
//       next = next.includes(value) ? next.filter((v) => v !== value) : [...next, value];

//       return { ...prev, target_audience: next.length ? next : ['all'] };
//     });
//   };

//   const fetchAnnouncements = async () => {
//     try {
//       if (!libraryId) return;

//       setLoading(true);
//       const data = await getAnnouncementsByLibrary(libraryId);
//       setAnnouncements(data || []);
//     } catch (error) {
//       Swal.fire('Error', getErrorMessage(error), 'error');
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchAnnouncements();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [libraryId]);

//   // Build/cleanup object URLs so image attachments can be previewed
//   useEffect(() => {
//     const urls = attachments.map((file) =>
//       isImage(file.name) ? URL.createObjectURL(file) : null
//     );
//     setAttachmentUrls(urls);

//     return () => urls.forEach((url) => url && URL.revokeObjectURL(url));
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [attachments]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const MAX_FILE_MB = 10;
//   const ALLOWED_EXT = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt', 'csv', 'jpg', 'jpeg', 'png'];

//   const handleFilesChange = (e) => {
//     const picked = Array.from(e.target.files || []);
//     if (picked.length === 0) return;

//     const valid = [];
//     for (const file of picked) {
//       const ext = file.name.split('.').pop().toLowerCase();
//       if (!ALLOWED_EXT.includes(ext)) {
//         Swal.fire('Invalid file', `"${file.name}" is not an allowed file type`, 'warning');
//         continue;
//       }
//       if (file.size > MAX_FILE_MB * 1024 * 1024) {
//         Swal.fire('File too large', `"${file.name}" exceeds ${MAX_FILE_MB} MB`, 'warning');
//         continue;
//       }
//       valid.push(file);
//     }

//     // Append to existing selection, avoid duplicates by name+size
//     setAttachments((prev) => {
//       const key = (f) => `${f.name}_${f.size}`;
//       const seen = new Set(prev.map(key));
//       return [...prev, ...valid.filter((f) => !seen.has(key(f)))];
//     });

//     e.target.value = ''; // allow re-selecting the same file
//   };

//   const removeAttachment = (index) => {
//     setAttachments((prev) => prev.filter((_, i) => i !== index));
//   };

//   const isImage = (name) =>
//     ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp'].includes(
//       String(name).split('.').pop().toLowerCase()
//     );

//   const fileIcon = (name) => {
//     const ext = String(name).split('.').pop().toLowerCase();
//     if (ext === 'pdf') return 'fas fa-file-pdf text-danger';
//     if (['doc', 'docx'].includes(ext)) return 'fas fa-file-word text-primary';
//     if (['xls', 'xlsx', 'csv'].includes(ext)) return 'fas fa-file-excel text-success';
//     if (['ppt', 'pptx'].includes(ext)) return 'fas fa-file-powerpoint text-warning';
//     if (['jpg', 'jpeg', 'png'].includes(ext)) return 'fas fa-file-image text-info';
//     return 'fas fa-file text-secondary';
//   };

//   const formatSize = (bytes) => {
//     if (bytes < 1024) return `${bytes} B`;
//     if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
//     return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
//   };

//   const resetForm = () => {
//     setFormData({
//       title: '',
//       message: '',
//       target_audience: ['all'],
//       publish_status: 'published',
//       publish_date: new Date().toISOString().slice(0, 10)
//     });
//     setAttachments([]);
//     setEditingId(null);
//   };

//   // Load an existing announcement into the form for editing
//   const handleEdit = (item) => {
//     setEditingId(item.id);
//     setFormData({
//       title: item.title || '',
//       message: item.message || '',
//       target_audience: audienceList(item.target_audience),
//       publish_status: item.publish_status || item.status || 'published',
//       publish_date: item.publish_date
//         ? String(item.publish_date).slice(0, 10)
//         : new Date().toISOString().slice(0, 10)
//     });
//     // Existing server-side attachments are kept as-is; new files can be added below
//     setAttachments([]);
//     window.scrollTo({ top: 0, behavior: 'smooth' });
//   };

//   // Step 1: validate then open the email preview instead of submitting directly
//   const handleSubmit = (e) => {
//     e.preventDefault();

//     if (!libraryId || !formData.title || !formData.message) {
//       Swal.fire('Error', 'Title and message are required', 'error');
//       return;
//     }

//     if (!formData.target_audience || formData.target_audience.length === 0) {
//       Swal.fire('Error', 'Please select at least one target audience', 'error');
//       return;
//     }

//     setPreviewEdit(false);
//     setShowPreview(true);
//   };

//   const closePreview = () => {
//     setShowPreview(false);
//     setPreviewEdit(false);
//   };

//   // Step 2: confirm from the preview modal -> actually save
//   const handleConfirmSave = async () => {
//     const fields = {
//       library_id: libraryId,
//       title: formData.title,
//       message: formData.message,
//       // Send selected audiences as a comma-separated list (e.g. "parents,students")
//       target_audience: (formData.target_audience || []).join(','),
//       publish_status: formData.publish_status,
//       publish_date: formData.publish_date || '',
//       created_by_staff_id: staffId
//     };

//     // Use multipart FormData when attachments exist, plain JSON otherwise.
//     let payload = fields;
//     if (attachments.length > 0) {
//       const fd = new FormData();
//       Object.entries(fields).forEach(([key, val]) => fd.append(key, val ?? ''));
//       attachments.forEach((file) => fd.append('attachments', file));
//       payload = fd;
//     }

//     try {
//       setLoading(true);
//       if (editingId) {
//         await updateAnnouncement(editingId, payload);
//       } else {
//         await addAnnouncement(payload);
//       }
//       setShowPreview(false);
//       Swal.fire(
//         'Success',
//         editingId
//           ? 'Announcement updated successfully'
//           : formData.publish_status === 'published'
//           ? 'Announcement published and email sent'
//           : 'Announcement saved as draft',
//         'success'
//       );
//       resetForm();
//       fetchAnnouncements();
//     } catch (error) {
//       Swal.fire('Error', getErrorMessage(error), 'error');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const oneAudienceLabel = (k) => {
//     if (k === 'all') return 'All Members';
//     if (k === 'parents') return 'Parents';
//     if (k === 'students') return 'Students';
//     if (k === 'staff') return 'Staff';
//     return k;
//   };

//   // Accepts an array, a comma string, or a single value
//   const audienceList = (a) => {
//     if (Array.isArray(a)) return a;
//     return String(a || 'all').split(',').map((s) => s.trim()).filter(Boolean);
//   };

//   const audienceLabel = (a) =>
//     audienceList(a).map((k) => oneAudienceLabel(String(k).toLowerCase())).join(', ');

//   // Gmail-style label colors per audience
//   const audienceColor = (a) => {
//     const k = String(a || 'all').toLowerCase();
//     if (k === 'parents') return { bg: '#e6f4ea', fg: '#137333' };
//     if (k === 'students') return { bg: '#e8f0fe', fg: '#1967d2' };
//     if (k === 'staff') return { bg: '#fce8e6', fg: '#c5221f' };
//     return { bg: '#fef7e0', fg: '#b06000' }; // all
//   };

//   const handleDelete = async (announcement) => {
//     const confirm = await Swal.fire({
//       title: 'Are you sure?',
//       text: 'Announcement will be deleted.',
//       icon: 'warning',
//       showCancelButton: true,
//       confirmButtonText: 'Yes, delete'
//     });

//     if (!confirm.isConfirmed) return;

//     try {
//       await deleteAnnouncement(announcement.id);
//       Swal.fire('Deleted', 'Announcement deleted successfully', 'success');
//       fetchAnnouncements();
//     } catch (error) {
//       Swal.fire('Error', getErrorMessage(error), 'error');
//     }
//   };

//   const getStatusBadge = (status) => {
//     if (status === 'published') return 'bg-success';
//     if (status === 'draft') return 'bg-secondary';
//     if (status === 'archived') return 'bg-dark';
//     return 'bg-light text-dark';
//   };

//   // Normalize attachments returned from the backend (array or JSON string)
//   const getAttachments = (item) => {
//     let list = item.attachments ?? item.files ?? [];
//     if (typeof list === 'string') {
//       try { list = JSON.parse(list); } catch { list = []; }
//     }
//     if (!Array.isArray(list)) return [];

//     return list.map((a) => {
//       const path = a.file_url || a.url || a.file_path || a.path || a;
//       const name = a.file_name || a.name || String(path).split('/').pop();
//       const url = /^https?:\/\//i.test(path) ? path : `${Constants.ROOT_URL}/${String(path).replace(/^\/+/, '')}`;
//       return { name, url };
//     });
//   };

//   const filteredAnnouncements = announcements.filter((item) => {
//     const keyword = search.toLowerCase();
//     const audience = Array.isArray(item.target_audience)
//       ? item.target_audience.join(' ')
//       : String(item.target_audience || '');

//     return (
//       String(item.title || '').toLowerCase().includes(keyword) ||
//       String(item.message || '').toLowerCase().includes(keyword) ||
//       audience.toLowerCase().includes(keyword)
//     );
//   });

//   return (
//     <div className="container-fluid mt-3">
//       <div className="d-flex justify-content-between align-items-center mb-3">
//         <div className="top-text-align">
//           <h3 className="mb-0">Announcements</h3>
//           <small className="text-muted">Create and manage library announcements</small>
//         </div>
//       </div>

//       <div className="row g-3">
//         {/* ════════ LEFT HALF: Create form ════════ */}
//         <div className="col-lg-6">
//           <div className="card shadow-sm h-100 table-full-card">
//             <div className="card-header fw-bold d-flex justify-content-between align-items-center">
//               <span>
//                 <i className="fas fa-bullhorn me-2" />
//                 {editingId ? 'Edit Announcement' : 'Create Announcement'}
//               </span>
//               {editingId && (
//                 <button
//                   type="button"
//                   className="btn btn-sm btn-outline-secondary"
//                   onClick={resetForm}
//                 >
//                   <i className="fas fa-times me-1" /> Cancel Edit
//                 </button>
//               )}
//             </div>

//             <div className="card-body">
//               <form onSubmit={handleSubmit}>
//                 <div className="mb-3">
//                   <label className="form-label">Title *</label>
//                   <input
//                     type="text"
//                     name="title"
//                     className="form-control"
//                     value={formData.title}
//                     onChange={handleChange}
//                     required
//                   />
//                 </div>

//                 <div className="row">
//                   <div className="col-6 mb-3">
//                     <label className="form-label">Status</label>
//                     <select
//                       name="publish_status"
//                       className="form-select"
//                       value={formData.publish_status}
//                       onChange={handleChange}
//                     >
//                       <option value="published">Published</option>
//                       <option value="draft">Draft</option>
//                       <option value="archived">Archived</option>
//                     </select>
//                   </div>

//                   <div className="col-6 mb-3">
//                     <label className="form-label">Publish Date</label>
//                     <input
//                       type="date"
//                       name="publish_date"
//                       className="form-control"
//                       value={formData.publish_date}
//                       onChange={handleChange}
//                     />
//                   </div>
//                 </div>

//                 {/* Target audience checkboxes (multi-select) */}
//                 <div className="mb-3">
//                   <label className="form-label">Target Audience *</label>
//                   <div className="d-flex flex-wrap gap-3 p-2" style={{ border: '1px solid #e2e8f0', borderRadius: 8 }}>
//                     {AUDIENCE_OPTIONS.map((opt) => (
//                       <div className="form-check" key={opt.value}>
//                         <input
//                           type="checkbox"
//                           className="form-check-input"
//                           id={`aud-${opt.value}`}
//                           checked={(formData.target_audience || []).includes(opt.value)}
//                           onChange={() => toggleAudience(opt.value)}
//                         />
//                         <label className="form-check-label" htmlFor={`aud-${opt.value}`}>
//                           {opt.label}
//                         </label>
//                       </div>
//                     ))}
//                   </div>
//                   <small className="text-muted">Message is sent only to the selected audience.</small>
//                 </div>

//                 <div className="mb-3">
//                   <label className="form-label">Message *</label>
//                   <textarea
//                     name="message"
//                     className="form-control"
//                     rows="3"
//                     value={formData.message}
//                     onChange={handleChange}
//                     required
//                   />
//                 </div>

//                 {/* ── Attachments section ── */}
//                 <div className="mb-3">
//                   <label className="form-label">
//                     Attachments <small className="text-muted">(PDF, Word, Excel, images — up to {MAX_FILE_MB} MB each)</small>
//                   </label>

//                   <div
//                     className="p-3 text-center"
//                     style={{ border: '2px dashed #cbd5e1', borderRadius: 10, background: '#f8fafc' }}
//                   >
//                     <i className="fas fa-cloud-upload-alt fs-3 text-primary mb-2 d-block" />
//                     <input
//                       id="ann-file-input"
//                       type="file"
//                       multiple
//                       accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv,.jpg,.jpeg,.png"
//                       className="d-none"
//                       onChange={handleFilesChange}
//                     />
//                     <label htmlFor="ann-file-input" className="btn btn-outline-primary btn-sm mb-1">
//                       <i className="fas fa-plus me-1" /> Choose Files
//                     </label>
//                     <div className="small text-muted">You can select multiple files at once</div>
//                   </div>

//                   {attachments.length > 0 && (
//                     <ul className="list-group mt-2">
//                       {attachments.map((file, index) => (
//                         <li
//                           key={`${file.name}_${file.size}_${index}`}
//                           className="list-group-item d-flex justify-content-between align-items-center"
//                         >
//                           <span className="text-truncate" style={{ maxWidth: '80%' }}>
//                             <i className={`${fileIcon(file.name)} me-2`} />
//                             {file.name}
//                             <small className="text-muted ms-2">{formatSize(file.size)}</small>
//                           </span>
//                           <button
//                             type="button"
//                             className="btn btn-sm btn-outline-danger"
//                             onClick={() => removeAttachment(index)}
//                           >
//                             <i className="fas fa-times" />
//                           </button>
//                         </li>
//                       ))}
//                     </ul>
//                   )}
//                 </div>

//                 <button className="btn btn-primary w-100" disabled={loading}>
//                   <i className="fas fa-eye me-1" /> Preview
//                 </button>
//               </form>
//             </div>
//           </div>
//         </div>

//         {/* ════════ RIGHT HALF: Announcement list ════════ */}
//         <div className="col-lg-6">
//           <div className="card shadow-sm h-100 table-full-card">
//             <div className="card-header fw-bold"><i className="fas fa-list me-2" />Announcement List</div>

//             <div className="card-body">
//               <div className="row g-2 align-items-center mb-3">
//                 <div className="col-7">
//                   <input
//                     type="text"
//                     className="form-control"
//                     placeholder="Search title, message, audience..."
//                     value={search}
//                     onChange={(e) => setSearch(e.target.value)}
//                   />
//                 </div>
//                 <div className="col-5">
//                   <button type="button" className="btn btn-outline-secondary w-100" onClick={() => setSearch('')}>
//                     Reset
//                   </button>
//                 </div>
//               </div>

//               <div className="table-responsive">
//                 <table className="table table-bordered table-hover align-middle">
//                   <thead className="table-light">
//                     <tr>
//                       <th style={{ width: 40 }}>#</th>
//                       <th>Title / Message</th>
//                       <th>Audience</th>
//                       <th className="text-center">Status</th>
//                       <th className="text-center">Action</th>
//                     </tr>
//                   </thead>

//                   <tbody>
//                     {filteredAnnouncements.length > 0 ? (
//                       filteredAnnouncements.map((item, index) => {
//                         const files = getAttachments(item);
//                         return (
//                           <tr key={item.id}>
//                             <td>{index + 1}</td>
//                             <td>
//                               <div className="fw-bold">{item.title || '-'}</div>
//                               <div className="small text-muted text-truncate" style={{ maxWidth: 220 }}>
//                                 {item.message || ''}
//                               </div>
//                               {files.length > 0 && (
//                                 <div className="d-flex flex-column gap-1 mt-1">
//                                   {files.map((f, i) => (
//                                     <a
//                                       key={i}
//                                       href={f.url}
//                                       target="_blank"
//                                       rel="noopener noreferrer"
//                                       className="text-decoration-none small"
//                                       title={f.name}
//                                     >
//                                       <i className={`${fileIcon(f.name)} me-1`} />
//                                       {f.name.length > 16 ? `${f.name.slice(0, 13)}...` : f.name}
//                                     </a>
//                                   ))}
//                                 </div>
//                               )}
//                             </td>
//                             <td>
//                               <div className="small">{audienceLabel(item.target_audience)}</div>
//                               <div className="small text-muted">
//                                 {item.publish_date ? String(item.publish_date).slice(0, 10) : '-'}
//                               </div>
//                             </td>
//                             <td className="text-center">
//                               <span className={`badge ${getStatusBadge(item.publish_status || item.status)}`}>
//                                 {item.publish_status || item.status || '-'}
//                               </span>
//                             </td>
//                             <td className="text-center">
//                               <button
//                                 className="btn btn-sm btn-outline-primary me-1"
//                                 onClick={() => handleEdit(item)}
//                                 title="Edit"
//                               >
//                                 <i className="fas fa-pen" />
//                               </button>
//                               <button
//                                 className="btn btn-sm btn-outline-danger"
//                                 onClick={() => handleDelete(item)}
//                                 title="Delete"
//                               >
//                                 <i className="fas fa-trash" />
//                               </button>
//                             </td>
//                           </tr>
//                         );
//                       })
//                     ) : (
//                       <tr>
//                         <td colSpan="5" className="text-center text-muted py-4">
//                           No announcements found
//                         </td>
//                       </tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* ════════════════ Email Preview Modal (Gmail-style) ════════════════ */}
//       {showPreview && (
//         <div
//           className="ann-modal-overlay"
//           onClick={(e) => e.target === e.currentTarget && closePreview()}
//           style={{
//             position: 'fixed', inset: 0, background: 'rgba(15,23,42,.55)',
//             display: 'flex', alignItems: 'center', justifyContent: 'center',
//             zIndex: 1060, padding: 16
//           }}
//         >
//           <div
//             style={{
//               background: '#fff', borderRadius: 14, width: '100%', maxWidth: 640,
//               maxHeight: '92vh', overflow: 'auto', boxShadow: '0 20px 50px rgba(2,28,55,.35)',
//               fontFamily: 'Segoe UI, Roboto, Arial, sans-serif'
//             }}
//           >
//             {/* Mail client toolbar */}
//             <div
//               className="d-flex justify-content-between align-items-center px-4 py-2"
//               style={{ background: '#f6f8fc', borderBottom: '1px solid #e3e8ef' }}
//             >
//               <div className="d-flex align-items-center gap-2" style={{ color: '#5f6368' }}>
//                 <i className="fas fa-inbox" />
//                 <span style={{ fontSize: 13, fontWeight: 600 }}>Email Preview</span>
//               </div>
//               <div className="d-flex align-items-center gap-3" style={{ color: '#5f6368' }}>
//                 {/* Edit toggle */}
//                 <button
//                   type="button"
//                   className="btn btn-sm"
//                   onClick={() => setPreviewEdit((p) => !p)}
//                   style={{
//                     background: previewEdit ? '#1a73e8' : 'transparent',
//                     color: previewEdit ? '#fff' : '#1a73e8',
//                     border: '1px solid #1a73e8', fontSize: 12, padding: '3px 12px', borderRadius: 16
//                   }}
//                 >
//                   <i className={`fas ${previewEdit ? 'fa-check' : 'fa-pen'} me-1`} />
//                   {previewEdit ? 'Done' : 'Edit'}
//                 </button>
//                 <i className="fas fa-times" role="button" onClick={closePreview} title="Close" />
//               </div>
//             </div>

//             {/* Subject line */}
//             <div className="px-4 pt-3 pb-2" style={{ borderBottom: '1px solid #f1f3f4' }}>
//               {previewEdit ? (
//                 <input
//                   type="text"
//                   name="title"
//                   value={formData.title}
//                   onChange={handleChange}
//                   className="form-control"
//                   placeholder="Subject"
//                   style={{ fontSize: 20, fontWeight: 600, border: '1px dashed #1a73e8' }}
//                 />
//               ) : (
//                 <h4 className="mb-0" style={{ color: '#202124', fontWeight: 500 }}>
//                   {formData.title || '(no subject)'}
//                 </h4>
//               )}

//               <div className="d-flex align-items-center gap-2 mt-2 flex-wrap">
//                 {/* Status chip (color-coded) */}
//                 <span
//                   style={{
//                     fontSize: 11, fontWeight: 700, padding: '2px 10px', borderRadius: 12,
//                     textTransform: 'capitalize',
//                     background: formData.publish_status === 'published' ? '#e6f4ea'
//                       : formData.publish_status === 'draft' ? '#f1f3f4' : '#e8eaed',
//                     color: formData.publish_status === 'published' ? '#137333'
//                       : formData.publish_status === 'draft' ? '#5f6368' : '#3c4043'
//                   }}
//                 >
//                   <i className={`fas ${formData.publish_status === 'published' ? 'fa-paper-plane' : 'fa-file-alt'} me-1`} />
//                   {formData.publish_status}
//                 </span>
//                 {/* Audience label chips (color-coded, one per selected audience) */}
//                 {audienceList(formData.target_audience).map((aud) => (
//                   <span
//                     key={aud}
//                     style={{
//                       fontSize: 11, fontWeight: 700, padding: '2px 10px', borderRadius: 12,
//                       background: audienceColor(aud).bg,
//                       color: audienceColor(aud).fg
//                     }}
//                   >
//                     {oneAudienceLabel(String(aud).toLowerCase())}
//                   </span>
//                 ))}
//               </div>
//             </div>

//             {/* Sender row */}
//             <div className="d-flex align-items-center gap-3 px-4 py-3">
//               <div
//                 style={{
//                   width: 42, height: 42, borderRadius: '50%', flexShrink: 0,
//                   background: 'linear-gradient(135deg,#4f46e5,#2563eb)', color: '#fff',
//                   display: 'flex', alignItems: 'center', justifyContent: 'center',
//                   fontSize: 18, fontWeight: 700
//                 }}
//               >
//                 CL
//               </div>
//               <div style={{ flex: 1, minWidth: 0 }}>
//                 <div style={{ fontSize: 14, color: '#202124' }}>
//                   <strong>Community Library</strong>{' '}
//                   <span style={{ color: '#5f6368', fontSize: 13 }}>&lt;no-reply@library.com&gt;</span>
//                 </div>
//                 <div style={{ fontSize: 12.5, color: '#5f6368' }}>
//                   to <strong>{audienceLabel(formData.target_audience)}</strong>
//                 </div>
//               </div>
//               <div style={{ fontSize: 12.5, color: '#5f6368', whiteSpace: 'nowrap' }}>
//                 {formData.publish_date || '-'}
//               </div>
//             </div>

//             {/* Body */}
//             <div className="px-4 pb-3" style={{ color: '#202124' }}>
//               {previewEdit ? (
//                 <textarea
//                   name="message"
//                   value={formData.message}
//                   onChange={handleChange}
//                   className="form-control"
//                   rows="6"
//                   placeholder="Message body"
//                   style={{ fontSize: 14.5, border: '1px dashed #1a73e8' }}
//                 />
//               ) : (
//                 <div style={{ fontSize: 14.5, lineHeight: 1.8, whiteSpace: 'pre-wrap' }}>
//                   {formData.message}
//                 </div>
//               )}

//               {attachments.length > 0 && (
//                 <div style={{ marginTop: 20 }}>
//                   <div style={{ fontSize: 13, color: '#5f6368', marginBottom: 8 }}>
//                     <i className="fas fa-paperclip me-1" />
//                     {attachments.length} Attachment{attachments.length > 1 ? 's' : ''}
//                   </div>
//                   <div className="d-flex flex-wrap gap-2">
//                     {attachments.map((file, i) => (
//                       <div
//                         key={i}
//                         style={{
//                           width: 150, border: '1px solid #dadce0',
//                           borderRadius: 8, fontSize: 13, background: '#f8f9fa', overflow: 'hidden'
//                         }}
//                       >
//                         {isImage(file.name) && attachmentUrls[i] ? (
//                           <a href={attachmentUrls[i]} target="_blank" rel="noopener noreferrer">
//                             <img
//                               src={attachmentUrls[i]}
//                               alt={file.name}
//                               style={{ width: '100%', height: 100, objectFit: 'cover', display: 'block' }}
//                             />
//                           </a>
//                         ) : (
//                           <div
//                             style={{
//                               height: 100, display: 'flex', alignItems: 'center',
//                               justifyContent: 'center', background: '#eef1f5'
//                             }}
//                           >
//                             <i className={`${fileIcon(file.name)}`} style={{ fontSize: 34 }} />
//                           </div>
//                         )}
//                         <div style={{ padding: '6px 8px' }}>
//                           <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
//                             {file.name}
//                           </div>
//                           <div style={{ color: '#94a3b8', fontSize: 11 }}>{formatSize(file.size)}</div>
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               )}

//               <div
//                 style={{
//                   marginTop: 22, paddingTop: 14, borderTop: '1px solid #f1f3f4',
//                   fontSize: 12, color: '#94a3b8'
//                 }}
//               >
//                 This is an automated message from your Community Library.
//               </div>
//             </div>

//             {/* Action bar */}
//             <div
//               className="d-flex justify-content-between align-items-center px-4 py-3"
//               style={{ borderTop: '1px solid #e3e8ef', background: '#f6f8fc' }}
//             >
//               <small className="text-muted">
//                 {formData.publish_status === 'published'
//                   ? 'This email will be sent to the selected audience'
//                   : 'Saved as draft — no email will be sent'}
//               </small>
//               <div className="d-flex gap-2">
//                 <button
//                   className="btn btn-outline-secondary"
//                   onClick={closePreview}
//                   disabled={loading}
//                 >
//                   Back to Form
//                 </button>
//                 <button
//                   className="btn btn-primary"
//                   onClick={handleConfirmSave}
//                   disabled={loading}
//                 >
//                   {loading
//                     ? 'Saving...'
//                     : editingId
//                       ? 'Update Announcement'
//                       : formData.publish_status === 'published'
//                         ? 'Publish & Send'
//                         : 'Save as Draft'}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default AnnouncementList;





// import React, { useEffect, useState } from 'react';
// import Swal from '../librarianSwal';
// import { useAuth } from '../../Constant/Auth';
// import * as Constants from '../../Constant/constant';

// import {
//   getAnnouncementsByLibrary,
//   addAnnouncement,
//   updateAnnouncement,
//   deleteAnnouncement,
//   getErrorMessage
// } from '../../api/api';

// const AnnouncementList = () => {
//   const { user } = useAuth();
//   const libraryId = useActiveLibraryId();
//   const staffId = user?.id || user?.staff_id;

//   const [announcements, setAnnouncements] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [search, setSearch] = useState('');
//   const [showPreview, setShowPreview] = useState(false);
//   const [previewEdit, setPreviewEdit] = useState(false);
//   const [attachments, setAttachments] = useState([]);
//   const [attachmentUrls, setAttachmentUrls] = useState([]);
//   const [editingId, setEditingId] = useState(null);

//   const [formData, setFormData] = useState({
//     title: '',
//     message: '',
//     target_audience: ['all'],
//     publish_status: 'published',
//     publish_date: new Date().toISOString().slice(0, 10)
//   });

//   const AUDIENCE_OPTIONS = [
//     { value: 'all', label: 'All' },
//     { value: 'parents', label: 'Parents' },
//     { value: 'students', label: 'Students' },
//     { value: 'staff', label: 'Staff' }
//   ];

//   const MAX_FILE_MB = 10;

//   const ALLOWED_EXT = [
//     'pdf',
//     'doc',
//     'docx',
//     'xls',
//     'xlsx',
//     'ppt',
//     'pptx',
//     'txt',
//     'csv',
//     'jpg',
//     'jpeg',
//     'png'
//   ];

//   const cleanValue = (value) => {
//     if (value === undefined || value === null) return '';
//     return String(value);
//   };

//   const getAnnouncementId = (item) => {
//     return item?.id || item?.announcement_id || item?.announcementId || null;
//   };

//   const getAnnouncementTitle = (item) => {
//     return (
//       item?.title ||
//       item?.announcement_title ||
//       item?.subject ||
//       item?.heading ||
//       ''
//     );
//   };

//   const getAnnouncementMessage = (item) => {
//     return (
//       item?.message ||
//       item?.announcement_message ||
//       item?.description ||
//       item?.content ||
//       item?.body ||
//       item?.details ||
//       item?.message_text ||
//       ''
//     );
//   };

//   const getAnnouncementStatus = (item) => {
//     return (
//       item?.publish_status ||
//       item?.status ||
//       item?.announcement_status ||
//       'published'
//     );
//   };

//   const getAnnouncementDate = (item) => {
//     const date =
//       item?.publish_date ||
//       item?.announcement_date ||
//       item?.created_at ||
//       item?.date;

//     return date
//       ? String(date).slice(0, 10)
//       : new Date().toISOString().slice(0, 10);
//   };

//   const oneAudienceLabel = (k) => {
//     if (k === 'all') return 'All Members';
//     if (k === 'parents') return 'Parents';
//     if (k === 'students') return 'Students';
//     if (k === 'staff') return 'Staff';
//     return k;
//   };

//   const audienceList = (a) => {
//     if (Array.isArray(a)) return a;

//     return String(a || 'all')
//       .split(',')
//       .map((s) => s.trim())
//       .filter(Boolean);
//   };

//   const audienceLabel = (a) =>
//     audienceList(a)
//       .map((k) => oneAudienceLabel(String(k).toLowerCase()))
//       .join(', ');

//   const audienceColor = (a) => {
//     const k = String(a || 'all').toLowerCase();

//     if (k === 'parents') return { bg: '#e6f4ea', fg: '#137333' };
//     if (k === 'students') return { bg: '#e8f0fe', fg: '#1967d2' };
//     if (k === 'staff') return { bg: '#fce8e6', fg: '#c5221f' };

//     return { bg: '#fef7e0', fg: '#b06000' };
//   };

//   const isImage = (name) =>
//     ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp'].includes(
//       String(name).split('.').pop().toLowerCase()
//     );

//   const fileIcon = (name) => {
//     const ext = String(name).split('.').pop().toLowerCase();

//     if (ext === 'pdf') return 'fas fa-file-pdf text-danger';
//     if (['doc', 'docx'].includes(ext)) return 'fas fa-file-word text-primary';
//     if (['xls', 'xlsx', 'csv'].includes(ext)) return 'fas fa-file-excel text-success';
//     if (['ppt', 'pptx'].includes(ext)) return 'fas fa-file-powerpoint text-warning';
//     if (['jpg', 'jpeg', 'png'].includes(ext)) return 'fas fa-file-image text-info';

//     return 'fas fa-file text-secondary';
//   };

//   const formatSize = (bytes) => {
//     if (!bytes) return '0 B';
//     if (bytes < 1024) return `${bytes} B`;
//     if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
//     return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
//   };

//   const toggleAudience = (value) => {
//     setFormData((prev) => {
//       const current = Array.isArray(prev.target_audience)
//         ? prev.target_audience
//         : [];

//       if (value === 'all') {
//         return { ...prev, target_audience: ['all'] };
//       }

//       let next = current.filter((v) => v !== 'all');

//       next = next.includes(value)
//         ? next.filter((v) => v !== value)
//         : [...next, value];

//       return {
//         ...prev,
//         target_audience: next.length ? next : ['all']
//       };
//     });
//   };

//   const fetchAnnouncements = async () => {
//     try {
//       if (!libraryId) return;

//       setLoading(true);

//       const result = await getAnnouncementsByLibrary(libraryId);

//       const list = Array.isArray(result)
//         ? result
//         : Array.isArray(result?.data)
//           ? result.data
//           : Array.isArray(result?.data?.data)
//             ? result.data.data
//             : [];

//       setAnnouncements(list);
//     } catch (error) {
//       Swal.fire('Error', getErrorMessage(error), 'error');
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchAnnouncements();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [libraryId]);

//   useEffect(() => {
//     const urls = attachments.map((file) =>
//       isImage(file.name) ? URL.createObjectURL(file) : null
//     );

//     setAttachmentUrls(urls);

//     return () => {
//       urls.forEach((url) => {
//         if (url) URL.revokeObjectURL(url);
//       });
//     };
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [attachments]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     setFormData((prev) => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const handleFilesChange = (e) => {
//     const picked = Array.from(e.target.files || []);

//     if (picked.length === 0) return;

//     const valid = [];

//     for (const file of picked) {
//       const ext = file.name.split('.').pop().toLowerCase();

//       if (!ALLOWED_EXT.includes(ext)) {
//         Swal.fire('Invalid file', `"${file.name}" is not an allowed file type`, 'warning');
//         continue;
//       }

//       if (file.size > MAX_FILE_MB * 1024 * 1024) {
//         Swal.fire('File too large', `"${file.name}" exceeds ${MAX_FILE_MB} MB`, 'warning');
//         continue;
//       }

//       valid.push(file);
//     }

//     setAttachments((prev) => {
//       const key = (f) => `${f.name}_${f.size}`;
//       const seen = new Set(prev.map(key));

//       return [...prev, ...valid.filter((f) => !seen.has(key(f)))];
//     });

//     e.target.value = '';
//   };

//   const removeAttachment = (index) => {
//     setAttachments((prev) => prev.filter((_, i) => i !== index));
//   };

//   const resetForm = () => {
//     setFormData({
//       title: '',
//       message: '',
//       target_audience: ['all'],
//       publish_status: 'published',
//       publish_date: new Date().toISOString().slice(0, 10)
//     });

//     setAttachments([]);
//     setEditingId(null);
//     setShowPreview(false);
//     setPreviewEdit(false);
//   };

//   const handleEdit = (item) => {
//     console.log('EDIT ANNOUNCEMENT ITEM:', item);

//     const id = getAnnouncementId(item);

//     setEditingId(id);

//     setFormData({
//       title: cleanValue(getAnnouncementTitle(item)),
//       message: cleanValue(getAnnouncementMessage(item)),
//       target_audience: audienceList(item?.target_audience || item?.audience || 'all'),
//       publish_status: getAnnouncementStatus(item),
//       publish_date: getAnnouncementDate(item)
//     });

//     setAttachments([]);
//     setShowPreview(false);
//     setPreviewEdit(false);

//     window.scrollTo({ top: 0, behavior: 'smooth' });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     if (!libraryId) {
//       Swal.fire('Error', 'Library ID not found', 'error');
//       return;
//     }

//     if (!formData.title.trim()) {
//       Swal.fire('Error', 'Title is required', 'error');
//       return;
//     }

//     if (!formData.message.trim()) {
//       Swal.fire('Error', 'Message is required', 'error');
//       return;
//     }

//     if (!formData.target_audience || formData.target_audience.length === 0) {
//       Swal.fire('Error', 'Please select at least one target audience', 'error');
//       return;
//     }

//     setPreviewEdit(false);
//     setShowPreview(true);
//   };

//   const closePreview = () => {
//     setShowPreview(false);
//     setPreviewEdit(false);
//   };

//   const handleConfirmSave = async () => {
//     const fields = {
//       library_id: libraryId,
//       title: formData.title.trim(),
//       message: formData.message.trim(),
//       target_audience: (formData.target_audience || []).join(','),
//       publish_status: formData.publish_status,
//       publish_date: formData.publish_date || '',
//       created_by_staff_id: staffId
//     };

//     let payload = fields;

//     if (attachments.length > 0) {
//       const fd = new FormData();

//       Object.entries(fields).forEach(([key, val]) => {
//         fd.append(key, val ?? '');
//       });

//       attachments.forEach((file) => {
//         fd.append('attachments', file);
//       });

//       payload = fd;
//     }

//     try {
//       setLoading(true);

//       if (editingId) {
//         await updateAnnouncement(editingId, payload);
//       } else {
//         await addAnnouncement(payload);
//       }

//       setShowPreview(false);

//       Swal.fire(
//         'Success',
//         editingId
//           ? 'Announcement updated successfully'
//           : formData.publish_status === 'published'
//             ? 'Announcement published and email sent'
//             : 'Announcement saved as draft',
//         'success'
//       );

//       resetForm();
//       fetchAnnouncements();
//     } catch (error) {
//       Swal.fire('Error', getErrorMessage(error), 'error');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleDelete = async (announcement) => {
//     const confirm = await Swal.fire({
//       title: 'Are you sure?',
//       text: 'Announcement will be deleted.',
//       icon: 'warning',
//       showCancelButton: true,
//       confirmButtonText: 'Yes, delete'
//     });

//     if (!confirm.isConfirmed) return;

//     try {
//       await deleteAnnouncement(getAnnouncementId(announcement));
//       Swal.fire('Deleted', 'Announcement deleted successfully', 'success');
//       fetchAnnouncements();
//     } catch (error) {
//       Swal.fire('Error', getErrorMessage(error), 'error');
//     }
//   };

//   const getStatusBadge = (status) => {
//     if (status === 'published') return 'bg-success';
//     if (status === 'draft') return 'bg-secondary';
//     if (status === 'archived') return 'bg-dark';

//     return 'bg-light text-dark';
//   };

//   const getAttachments = (item) => {
//     let list = item?.attachments ?? item?.files ?? [];

//     if (typeof list === 'string') {
//       try {
//         list = JSON.parse(list);
//       } catch {
//         list = [];
//       }
//     }

//     if (!Array.isArray(list)) return [];

//     return list.map((a) => {
//       const path = a.file_url || a.url || a.file_path || a.path || a;
//       const name = a.file_name || a.name || String(path).split('/').pop();

//       const url = /^https?:\/\//i.test(path)
//         ? path
//         : `${Constants.ROOT_URL}/${String(path).replace(/^\/+/, '')}`;

//       return { name, url };
//     });
//   };

//   const filteredAnnouncements = announcements.filter((item) => {
//     const keyword = search.toLowerCase();

//     const title = getAnnouncementTitle(item);
//     const message = getAnnouncementMessage(item);

//     const audience = Array.isArray(item.target_audience)
//       ? item.target_audience.join(' ')
//       : String(item.target_audience || item.audience || '');

//     return (
//       String(title).toLowerCase().includes(keyword) ||
//       String(message).toLowerCase().includes(keyword) ||
//       audience.toLowerCase().includes(keyword)
//     );
//   });

//   return (
//     <div className="container-fluid mt-3">
//       <div className="d-flex justify-content-between align-items-center mb-3">
//         <div className="top-text-align">
//           <h3 className="mb-0">Announcements</h3>
//           <small className="text-muted">Create and manage library announcements</small>
//         </div>
//       </div>

//       <div className="row g-3">
//         <div className="col-lg-6">
//           <div className="card shadow-sm h-100 table-full-card">
//             <div className="card-header fw-bold d-flex justify-content-between align-items-center">
//               <span>
//                 <i className="fas fa-bullhorn me-2" />
//                 {editingId ? 'Edit Announcement' : 'Create Announcement'}
//               </span>

//               {editingId && (
//                 <button
//                   type="button"
//                   className="btn btn-sm btn-outline-secondary"
//                   onClick={resetForm}
//                 >
//                   <i className="fas fa-times me-1" /> Cancel Edit
//                 </button>
//               )}
//             </div>

//             <div className="card-body">
//               <form onSubmit={handleSubmit}>
//                 <div className="mb-3">
//                   <label className="form-label">Title *</label>
//                   <input
//                     type="text"
//                     name="title"
//                     className="form-control"
//                     value={formData.title}
//                     onChange={handleChange}
//                     required
//                   />
//                 </div>

//                 <div className="row">
//                   <div className="col-6 mb-3">
//                     <label className="form-label">Status</label>
//                     <select
//                       name="publish_status"
//                       className="form-select"
//                       value={formData.publish_status}
//                       onChange={handleChange}
//                     >
//                       <option value="published">Published</option>
//                       <option value="draft">Draft</option>
//                       <option value="archived">Archived</option>
//                     </select>
//                   </div>

//                   <div className="col-6 mb-3">
//                     <label className="form-label">Publish Date</label>
//                     <input
//                       type="date"
//                       name="publish_date"
//                       className="form-control"
//                       value={formData.publish_date}
//                       onChange={handleChange}
//                     />
//                   </div>
//                 </div>

//                 <div className="mb-3">
//                   <label className="form-label">Target Audience *</label>

//                   <div
//                     className="d-flex flex-wrap gap-3 p-2"
//                     style={{
//                       border: '1px solid #e2e8f0',
//                       borderRadius: 8
//                     }}
//                   >
//                     {AUDIENCE_OPTIONS.map((opt) => (
//                       <div className="form-check" key={opt.value}>
//                         <input
//                           type="checkbox"
//                           className="form-check-input"
//                           id={`aud-${opt.value}`}
//                           checked={(formData.target_audience || []).includes(opt.value)}
//                           onChange={() => toggleAudience(opt.value)}
//                         />

//                         <label className="form-check-label" htmlFor={`aud-${opt.value}`}>
//                           {opt.label}
//                         </label>
//                       </div>
//                     ))}
//                   </div>

//                   <small className="text-muted">
//                     Message is sent only to the selected audience.
//                   </small>
//                 </div>

//                 <div className="mb-3">
//                   <label className="form-label">Message *</label>
//                   <textarea
//                     name="message"
//                     className="form-control"
//                     rows="3"
//                     value={formData.message}
//                     onChange={handleChange}
//                     required
//                   />
//                 </div>

//                 <div className="mb-3">
//                   <label className="form-label">
//                     Attachments{' '}
//                     <small className="text-muted">
//                       (PDF, Word, Excel, images — up to {MAX_FILE_MB} MB each)
//                     </small>
//                   </label>

//                   <div
//                     className="p-3 text-center"
//                     style={{
//                       border: '2px dashed #cbd5e1',
//                       borderRadius: 10,
//                       background: '#f8fafc'
//                     }}
//                   >
//                     <i className="fas fa-cloud-upload-alt fs-3 text-primary mb-2 d-block" />

//                     <input
//                       id="ann-file-input"
//                       type="file"
//                       multiple
//                       accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv,.jpg,.jpeg,.png"
//                       className="d-none"
//                       onChange={handleFilesChange}
//                     />

//                     <label htmlFor="ann-file-input" className="btn btn-outline-primary btn-sm mb-1">
//                       <i className="fas fa-plus me-1" /> Choose Files
//                     </label>

//                     <div className="small text-muted">
//                       You can select multiple files at once
//                     </div>
//                   </div>

//                   {attachments.length > 0 && (
//                     <ul className="list-group mt-2">
//                       {attachments.map((file, index) => (
//                         <li
//                           key={`${file.name}_${file.size}_${index}`}
//                           className="list-group-item d-flex justify-content-between align-items-center"
//                         >
//                           <span
//                             className="text-truncate"
//                             style={{ maxWidth: '80%' }}
//                           >
//                             <i className={`${fileIcon(file.name)} me-2`} />
//                             {file.name}
//                             <small className="text-muted ms-2">
//                               {formatSize(file.size)}
//                             </small>
//                           </span>

//                           <button
//                             type="button"
//                             className="btn btn-sm btn-outline-danger"
//                             onClick={() => removeAttachment(index)}
//                           >
//                             <i className="fas fa-times" />
//                           </button>
//                         </li>
//                       ))}
//                     </ul>
//                   )}
//                 </div>

//                 <button className="btn btn-primary w-100" disabled={loading}>
//                   <i className="fas fa-eye me-1" />
//                   {editingId ? 'Preview Update' : 'Preview'}
//                 </button>
//               </form>
//             </div>
//           </div>
//         </div>

//         <div className="col-lg-6">
//           <div className="card shadow-sm h-100 table-full-card">
//             <div className="card-header fw-bold">
//               <i className="fas fa-list me-2" />
//               Announcement List
//             </div>

//             <div className="card-body">
//               <div className="row g-2 align-items-center mb-3">
//                 <div className="col-7">
//                   <input
//                     type="text"
//                     className="form-control"
//                     placeholder="Search title, message, audience..."
//                     value={search}
//                     onChange={(e) => setSearch(e.target.value)}
//                   />
//                 </div>

//                 <div className="col-5">
//                   <button
//                     type="button"
//                     className="btn btn-outline-secondary w-100"
//                     onClick={() => setSearch('')}
//                   >
//                     Reset
//                   </button>
//                 </div>
//               </div>

//               <div className="table-responsive">
//                 <table className="table table-bordered table-hover align-middle">
//                   <thead className="table-light">
//                     <tr>
//                       <th style={{ width: 40 }}>#</th>
//                       <th>Title / Message</th>
//                       <th>Audience</th>
//                       <th className="text-center">Status</th>
//                       <th className="text-center">Action</th>
//                     </tr>
//                   </thead>

//                   <tbody>
//                     {filteredAnnouncements.length > 0 ? (
//                       filteredAnnouncements.map((item, index) => {
//                         const files = getAttachments(item);

//                         return (
//                           <tr key={getAnnouncementId(item) || index}>
//                             <td>{index + 1}</td>

//                             <td>
//                               <div className="fw-bold">
//                                 {getAnnouncementTitle(item) || '-'}
//                               </div>

//                               <div
//                                 className="small text-muted text-truncate"
//                                 style={{ maxWidth: 220 }}
//                               >
//                                 {getAnnouncementMessage(item) || '-'}
//                               </div>

//                               {files.length > 0 && (
//                                 <div className="d-flex flex-column gap-1 mt-1">
//                                   {files.map((f, i) => (
//                                     <a
//                                       key={i}
//                                       href={f.url}
//                                       target="_blank"
//                                       rel="noopener noreferrer"
//                                       className="text-decoration-none small"
//                                       title={f.name}
//                                     >
//                                       <i className={`${fileIcon(f.name)} me-1`} />
//                                       {f.name.length > 16
//                                         ? `${f.name.slice(0, 13)}...`
//                                         : f.name}
//                                     </a>
//                                   ))}
//                                 </div>
//                               )}
//                             </td>

//                             <td>
//                               <div className="small">
//                                 {audienceLabel(item.target_audience || item.audience)}
//                               </div>

//                               <div className="small text-muted">
//                                 {getAnnouncementDate(item)}
//                               </div>
//                             </td>

//                             <td className="text-center">
//                               <span className={`badge ${getStatusBadge(getAnnouncementStatus(item))}`}>
//                                 {getAnnouncementStatus(item)}
//                               </span>
//                             </td>

//                             <td className="text-center">
//                               <button
//                                 type="button"
//                                 className="btn btn-sm btn-outline-primary me-1"
//                                 onClick={() => handleEdit(item)}
//                                 title="Edit"
//                               >
//                                 <i className="fas fa-pen" />
//                               </button>

//                               <button
//                                 type="button"
//                                 className="btn btn-sm btn-outline-danger"
//                                 onClick={() => handleDelete(item)}
//                                 title="Delete"
//                               >
//                                 <i className="fas fa-trash" />
//                               </button>
//                             </td>
//                           </tr>
//                         );
//                       })
//                     ) : (
//                       <tr>
//                         <td colSpan="5" className="text-center text-muted py-4">
//                           No announcements found
//                         </td>
//                       </tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>

//               {loading && (
//                 <div className="text-center text-muted small mt-2">
//                   Loading...
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>

//       {showPreview && (
//         <div
//           className="ann-modal-overlay"
//           onClick={(e) => e.target === e.currentTarget && closePreview()}
//           style={{
//             position: 'fixed',
//             inset: 0,
//             background: 'rgba(15,23,42,.55)',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             zIndex: 1060,
//             padding: 16
//           }}
//         >
//           <div
//             style={{
//               background: '#fff',
//               borderRadius: 14,
//               width: '100%',
//               maxWidth: 640,
//               maxHeight: '92vh',
//               overflow: 'auto',
//               boxShadow: '0 20px 50px rgba(2,28,55,.35)',
//               fontFamily: 'Segoe UI, Roboto, Arial, sans-serif'
//             }}
//           >
//             <div
//               className="d-flex justify-content-between align-items-center px-4 py-2"
//               style={{
//                 background: '#f6f8fc',
//                 borderBottom: '1px solid #e3e8ef'
//               }}
//             >
//               <div
//                 className="d-flex align-items-center gap-2"
//                 style={{ color: '#5f6368' }}
//               >
//                 <i className="fas fa-inbox" />
//                 <span style={{ fontSize: 13, fontWeight: 600 }}>
//                   Email Preview
//                 </span>
//               </div>

//               <div
//                 className="d-flex align-items-center gap-3"
//                 style={{ color: '#5f6368' }}
//               >
//                 <button
//                   type="button"
//                   className="btn btn-sm"
//                   onClick={() => setPreviewEdit((p) => !p)}
//                   style={{
//                     background: previewEdit ? '#1a73e8' : 'transparent',
//                     color: previewEdit ? '#fff' : '#1a73e8',
//                     border: '1px solid #1a73e8',
//                     fontSize: 12,
//                     padding: '3px 12px',
//                     borderRadius: 16
//                   }}
//                 >
//                   <i className={`fas ${previewEdit ? 'fa-check' : 'fa-pen'} me-1`} />
//                   {previewEdit ? 'Done' : 'Edit'}
//                 </button>

//                 <i
//                   className="fas fa-times"
//                   role="button"
//                   onClick={closePreview}
//                   title="Close"
//                 />
//               </div>
//             </div>

//             <div
//               className="px-4 pt-3 pb-2"
//               style={{ borderBottom: '1px solid #f1f3f4' }}
//             >
//               {previewEdit ? (
//                 <input
//                   type="text"
//                   name="title"
//                   value={formData.title}
//                   onChange={handleChange}
//                   className="form-control"
//                   placeholder="Subject"
//                   style={{
//                     fontSize: 20,
//                     fontWeight: 600,
//                     border: '1px dashed #1a73e8'
//                   }}
//                 />
//               ) : (
//                 <h4
//                   className="mb-0"
//                   style={{
//                     color: '#202124',
//                     fontWeight: 500
//                   }}
//                 >
//                   {formData.title || '(no subject)'}
//                 </h4>
//               )}

//               <div className="d-flex align-items-center gap-2 mt-2 flex-wrap">
//                 <span
//                   style={{
//                     fontSize: 11,
//                     fontWeight: 700,
//                     padding: '2px 10px',
//                     borderRadius: 12,
//                     textTransform: 'capitalize',
//                     background:
//                       formData.publish_status === 'published'
//                         ? '#e6f4ea'
//                         : formData.publish_status === 'draft'
//                           ? '#f1f3f4'
//                           : '#e8eaed',
//                     color:
//                       formData.publish_status === 'published'
//                         ? '#137333'
//                         : formData.publish_status === 'draft'
//                           ? '#5f6368'
//                           : '#3c4043'
//                   }}
//                 >
//                   <i
//                     className={`fas ${
//                       formData.publish_status === 'published'
//                         ? 'fa-paper-plane'
//                         : 'fa-file-alt'
//                     } me-1`}
//                   />
//                   {formData.publish_status}
//                 </span>

//                 {audienceList(formData.target_audience).map((aud) => (
//                   <span
//                     key={aud}
//                     style={{
//                       fontSize: 11,
//                       fontWeight: 700,
//                       padding: '2px 10px',
//                       borderRadius: 12,
//                       background: audienceColor(aud).bg,
//                       color: audienceColor(aud).fg
//                     }}
//                   >
//                     {oneAudienceLabel(String(aud).toLowerCase())}
//                   </span>
//                 ))}
//               </div>
//             </div>

//             <div className="d-flex align-items-center gap-3 px-4 py-3">
//               <div
//                 style={{
//                   width: 42,
//                   height: 42,
//                   borderRadius: '50%',
//                   flexShrink: 0,
//                   background: 'linear-gradient(135deg,#4f46e5,#2563eb)',
//                   color: '#fff',
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   fontSize: 18,
//                   fontWeight: 700
//                 }}
//               >
//                 CL
//               </div>

//               <div style={{ flex: 1, minWidth: 0 }}>
//                 <div style={{ fontSize: 14, color: '#202124' }}>
//                   <strong>Community Library</strong>{' '}
//                   <span style={{ color: '#5f6368', fontSize: 13 }}>
//                     &lt;no-reply@library.com&gt;
//                   </span>
//                 </div>

//                 <div style={{ fontSize: 12.5, color: '#5f6368' }}>
//                   to <strong>{audienceLabel(formData.target_audience)}</strong>
//                 </div>
//               </div>

//               <div
//                 style={{
//                   fontSize: 12.5,
//                   color: '#5f6368',
//                   whiteSpace: 'nowrap'
//                 }}
//               >
//                 {formData.publish_date || '-'}
//               </div>
//             </div>

//             <div className="px-4 pb-3" style={{ color: '#202124' }}>
//               {previewEdit ? (
//                 <textarea
//                   name="message"
//                   value={formData.message}
//                   onChange={handleChange}
//                   className="form-control"
//                   rows="6"
//                   placeholder="Message body"
//                   style={{
//                     fontSize: 14.5,
//                     border: '1px dashed #1a73e8'
//                   }}
//                 />
//               ) : (
//                 <div
//                   style={{
//                     fontSize: 14.5,
//                     lineHeight: 1.8,
//                     whiteSpace: 'pre-wrap'
//                   }}
//                 >
//                   {formData.message}
//                 </div>
//               )}

//               {attachments.length > 0 && (
//                 <div style={{ marginTop: 20 }}>
//                   <div
//                     style={{
//                       fontSize: 13,
//                       color: '#5f6368',
//                       marginBottom: 8
//                     }}
//                   >
//                     <i className="fas fa-paperclip me-1" />
//                     {attachments.length} Attachment
//                     {attachments.length > 1 ? 's' : ''}
//                   </div>

//                   <div className="d-flex flex-wrap gap-2">
//                     {attachments.map((file, i) => (
//                       <div
//                         key={`${file.name}_${i}`}
//                         style={{
//                           width: 150,
//                           border: '1px solid #dadce0',
//                           borderRadius: 8,
//                           fontSize: 13,
//                           background: '#f8f9fa',
//                           overflow: 'hidden'
//                         }}
//                       >
//                         {isImage(file.name) && attachmentUrls[i] ? (
//                           <a
//                             href={attachmentUrls[i]}
//                             target="_blank"
//                             rel="noopener noreferrer"
//                           >
//                             <img
//                               src={attachmentUrls[i]}
//                               alt={file.name}
//                               style={{
//                                 width: '100%',
//                                 height: 100,
//                                 objectFit: 'cover',
//                                 display: 'block'
//                               }}
//                             />
//                           </a>
//                         ) : (
//                           <div
//                             style={{
//                               height: 100,
//                               display: 'flex',
//                               alignItems: 'center',
//                               justifyContent: 'center',
//                               background: '#eef1f5'
//                             }}
//                           >
//                             <i
//                               className={`${fileIcon(file.name)}`}
//                               style={{ fontSize: 34 }}
//                             />
//                           </div>
//                         )}

//                         <div style={{ padding: '6px 8px' }}>
//                           <div
//                             style={{
//                               overflow: 'hidden',
//                               textOverflow: 'ellipsis',
//                               whiteSpace: 'nowrap'
//                             }}
//                           >
//                             {file.name}
//                           </div>

//                           <div
//                             style={{
//                               color: '#94a3b8',
//                               fontSize: 11
//                             }}
//                           >
//                             {formatSize(file.size)}
//                           </div>
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               )}

//               <div
//                 style={{
//                   marginTop: 22,
//                   paddingTop: 14,
//                   borderTop: '1px solid #f1f3f4',
//                   fontSize: 12,
//                   color: '#94a3b8'
//                 }}
//               >
//                 This is an automated message from your Community Library.
//               </div>
//             </div>

//             <div
//               className="d-flex justify-content-between align-items-center px-4 py-3"
//               style={{
//                 borderTop: '1px solid #e3e8ef',
//                 background: '#f6f8fc'
//               }}
//             >
//               <small className="text-muted">
//                 {formData.publish_status === 'published'
//                   ? 'This email will be sent to the selected audience'
//                   : 'Saved as draft — no email will be sent'}
//               </small>

//               <div className="d-flex gap-2">
//                 <button
//                   type="button"
//                   className="btn btn-outline-secondary"
//                   onClick={closePreview}
//                   disabled={loading}
//                 >
//                   Back to Form
//                 </button>

//                 <button
//                   type="button"
//                   className="btn btn-primary"
//                   onClick={handleConfirmSave}
//                   disabled={loading}
//                 >
//                   {loading
//                     ? 'Saving...'
//                     : editingId
//                       ? 'Update Announcement'
//                       : formData.publish_status === 'published'
//                         ? 'Publish & Send'
//                         : 'Save as Draft'}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default AnnouncementList;





import React, { useEffect, useRef, useState } from 'react';
import Swal from '../librarianSwal';
import { useAuth } from '../../Constant/Auth';
import * as Constants from '../../Constant/constant';
import Loader from '../../Layout/Loader';
import SearchableSelect from '../../shared/SearchableSelect';
import Pagination from '../components/Pagination';
import '../lib-page-header.css';

import {
  getAnnouncementsByLibrary,
  getAnnouncementById,
  addAnnouncement,
  updateAnnouncement,
  deleteAnnouncement,
  getErrorMessage
} from '../../api/api';

const PAGE_SIZE = 10;

const AnnouncementList = () => {
  const { user } = useAuth();

  const libraryId = useActiveLibraryId();
  const staffId = user?.id || user?.staff_id;

  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [showPreview, setShowPreview] = useState(false);
  const [previewEdit, setPreviewEdit] = useState(false);
  const [attachments, setAttachments] = useState([]);
  const [attachmentUrls, setAttachmentUrls] = useState([]);
  // Files already uploaded to the announcement being edited
  const [existingAttachments, setExistingAttachments] = useState([]);
  // ids (from existingAttachments) staged for removal on the next save
  const [removedAttachmentIds, setRemovedAttachmentIds] = useState([]);
  const [editingId, setEditingId] = useState(null);

  const formSectionRef = useRef(null);
  const isEditMode = editingId !== null && editingId !== undefined;

  const [formData, setFormData] = useState({
    title: '',
    message: '',
    target_audience: ['all'],
    publish_status: 'published',
    publish_date: new Date().toISOString().slice(0, 10)
  });

  const AUDIENCE_OPTIONS = [
    { value: 'all', label: 'All' },
    { value: 'parents', label: 'Parents' },
    { value: 'students', label: 'Students' },
    { value: 'staff', label: 'Staff' }
  ];

  const MAX_FILE_MB = 10;

  const ALLOWED_EXT = [
    'pdf',
    'doc',
    'docx',
    'xls',
    'xlsx',
    'ppt',
    'pptx',
    'txt',
    'csv',
    'jpg',
    'jpeg',
    'png'
  ];

  const cleanValue = (value) => {
    if (value === undefined || value === null) return '';
    return String(value);
  };

  const normalizeStatus = (status) => {
    const value = String(status || 'published').toLowerCase();

    if (value === 'draft') return 'draft';
    if (value === 'archived') return 'archived';
    if (value === 'published') return 'published';

    return 'published';
  };

  const getAnnouncementId = (item) => {
    return item?.id || item?.announcement_id || item?.announcementId || null;
  };

  const getAnnouncementTitle = (item) => {
    return (
      item?.title ||
      item?.announcement_title ||
      item?.subject ||
      item?.heading ||
      ''
    );
  };

  const getAnnouncementMessage = (item) => {
    return (
      item?.message ||
      item?.announcement_message ||
      item?.description ||
      item?.content ||
      item?.body ||
      item?.details ||
      item?.message_text ||
      ''
    );
  };

  const getAnnouncementStatus = (item) => {
    return normalizeStatus(
      item?.publish_status ||
        item?.status ||
        item?.announcement_status ||
        'published'
    );
  };

  const getAnnouncementDate = (item) => {
    const date =
      item?.publish_date ||
      item?.announcement_date ||
      item?.created_at ||
      item?.date;

    return date
      ? String(date).slice(0, 10)
      : new Date().toISOString().slice(0, 10);
  };

  const oneAudienceLabel = (key) => {
    if (key === 'all') return 'All Members';
    if (key === 'parents') return 'Parents';
    if (key === 'students') return 'Students';
    if (key === 'staff') return 'Staff';

    return key;
  };

  const audienceList = (audience) => {
    if (Array.isArray(audience)) return audience;

    return String(audience || 'all')
      .split(',')
      .map((item) => item.trim())
      .filter(Boolean);
  };

  const audienceLabel = (audience) => {
    return audienceList(audience)
      .map((key) => oneAudienceLabel(String(key).toLowerCase()))
      .join(', ');
  };

  const audienceColor = (audience) => {
    const key = String(audience || 'all').toLowerCase();

    if (key === 'parents') return { bg: '#e6f4ea', fg: '#137333' };
    if (key === 'students') return { bg: '#e8f0fe', fg: '#1967d2' };
    if (key === 'staff') return { bg: '#fce8e6', fg: '#c5221f' };

    return { bg: '#fef7e0', fg: '#b06000' };
  };

  const isImage = (name) => {
    const ext = String(name).split('.').pop().toLowerCase();

    return ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp'].includes(ext);
  };

  const fileIcon = (name) => {
    const ext = String(name).split('.').pop().toLowerCase();

    if (ext === 'pdf') return 'fas fa-file-pdf text-danger';
    if (['doc', 'docx'].includes(ext)) return 'fas fa-file-word text-primary';
    if (['xls', 'xlsx', 'csv'].includes(ext)) return 'fas fa-file-excel text-success';
    if (['ppt', 'pptx'].includes(ext)) return 'fas fa-file-powerpoint text-warning';
    if (['jpg', 'jpeg', 'png'].includes(ext)) return 'fas fa-file-image text-info';

    return 'fas fa-file text-secondary';
  };

  const formatSize = (bytes) => {
    if (!bytes) return '0 B';
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;

    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  };

  const fetchAnnouncements = async () => {
    try {
      if (!libraryId) return;

      setLoading(true);

      const result = await getAnnouncementsByLibrary(libraryId);

      const list = Array.isArray(result)
        ? result
        : Array.isArray(result?.data)
          ? result.data
          : Array.isArray(result?.data?.data)
            ? result.data.data
            : [];

      setAnnouncements(list);
    } catch (error) {
      Swal.fire('Error', getErrorMessage(error), 'error');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAnnouncements();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [libraryId]);

  useEffect(() => {
    const urls = attachments.map((file) =>
      isImage(file.name) ? URL.createObjectURL(file) : null
    );

    setAttachmentUrls(urls);

    return () => {
      urls.forEach((url) => {
        if (url) URL.revokeObjectURL(url);
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [attachments]);

  const handleChange = (event) => {
    const { name, value } = event.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const toggleAudience = (value) => {
    setFormData((prev) => {
      const current = Array.isArray(prev.target_audience)
        ? prev.target_audience
        : [];

      if (value === 'all') {
        return {
          ...prev,
          target_audience: ['all']
        };
      }

      let next = current.filter((item) => item !== 'all');

      next = next.includes(value)
        ? next.filter((item) => item !== value)
        : [...next, value];

      return {
        ...prev,
        target_audience: next.length ? next : ['all']
      };
    });
  };

  const handleFilesChange = (event) => {
    const picked = Array.from(event.target.files || []);

    if (picked.length === 0) return;

    const valid = [];

    for (const file of picked) {
      const ext = file.name.split('.').pop().toLowerCase();

      if (!ALLOWED_EXT.includes(ext)) {
        Swal.fire(
          'Invalid file',
          `"${file.name}" is not an allowed file type`,
          'warning'
        );
        continue;
      }

      if (file.size > MAX_FILE_MB * 1024 * 1024) {
        Swal.fire(
          'File too large',
          `"${file.name}" exceeds ${MAX_FILE_MB} MB`,
          'warning'
        );
        continue;
      }

      valid.push(file);
    }

    setAttachments((prev) => {
      const key = (file) => `${file.name}_${file.size}`;
      const seen = new Set(prev.map(key));

      return [...prev, ...valid.filter((file) => !seen.has(key(file)))];
    });

    event.target.value = '';
  };

  const removeAttachment = (index) => {
    setAttachments((prev) => prev.filter((_, itemIndex) => itemIndex !== index));
  };

  const toggleRemoveExistingAttachment = (attachmentId) => {
    if (attachmentId === null || attachmentId === undefined) return;

    setRemovedAttachmentIds((prev) =>
      prev.includes(attachmentId)
        ? prev.filter((id) => id !== attachmentId)
        : [...prev, attachmentId]
    );
  };

  const resetForm = () => {
    setFormData({
      title: '',
      message: '',
      target_audience: ['all'],
      publish_status: 'published',
      publish_date: new Date().toISOString().slice(0, 10)
    });

    setAttachments([]);
    setExistingAttachments([]);
    setRemovedAttachmentIds([]);
    setEditingId(null);
    setShowPreview(false);
    setPreviewEdit(false);
  };

  const handleEdit = async (item) => {
    const id = getAnnouncementId(item);

    setEditingId(id);

    setFormData({
      title: cleanValue(getAnnouncementTitle(item)),
      message: cleanValue(getAnnouncementMessage(item)),
      target_audience: audienceList(item?.target_audience || item?.audience || 'all'),
      publish_status: getAnnouncementStatus(item),
      publish_date: getAnnouncementDate(item)
    });

    setAttachments([]);
    setRemovedAttachmentIds([]);
    // Show whatever the list row already has, then enrich from the detail API.
    setExistingAttachments(getAttachments(item));
    setShowPreview(false);
    setPreviewEdit(false);

    setTimeout(() => {
      formSectionRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }, 100);

    // The list endpoint often omits attachments — fetch the full announcement
    // so its uploaded files can be previewed while editing.
    if (id) {
      const detail = await getAnnouncementById(id);
      if (detail) {
        const detailFiles = getAttachments(detail);
        if (detailFiles.length > 0) {
          setExistingAttachments(detailFiles);
        }
      }
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!libraryId) {
      Swal.fire('Error', 'Library ID not found', 'error');
      return;
    }

    if (!formData.title.trim()) {
      Swal.fire('Error', 'Title is required', 'error');
      return;
    }

    if (!formData.message.trim()) {
      Swal.fire('Error', 'Message is required', 'error');
      return;
    }

    if (!formData.target_audience || formData.target_audience.length === 0) {
      Swal.fire('Error', 'Please select at least one target audience', 'error');
      return;
    }

    setPreviewEdit(false);
    setShowPreview(true);
  };

  const closePreview = () => {
    setShowPreview(false);
    setPreviewEdit(false);
  };

  const handleConfirmSave = async () => {
    const fields = {
      library_id: libraryId,
      title: formData.title.trim(),
      message: formData.message.trim(),
      target_audience: (formData.target_audience || []).join(','),
      status: formData.publish_status,
      publish_date: formData.publish_date || '',
      created_by_staff_id: staffId || ''
    };

    let payload = fields;

    // Only switch to multipart when there's actually a file/removal to send
    // — keeps a plain text-only edit exactly as before.
    const hasFileChanges = attachments.length > 0 || removedAttachmentIds.length > 0;

    if (hasFileChanges) {
      const fd = new FormData();

      Object.entries(fields).forEach(([key, value]) => {
        fd.append(key, value ?? '');
      });

      attachments.forEach((file) => {
        fd.append('attachments', file);
      });

      if (isEditMode && removedAttachmentIds.length > 0) {
        fd.append('remove_attachment_ids', JSON.stringify(removedAttachmentIds));
      }

      payload = fd;
    }

    try {
      setLoading(true);

      if (isEditMode) {
        await updateAnnouncement(editingId, payload);
      } else {
        await addAnnouncement(payload);
      }

      setShowPreview(false);

      Swal.fire(
        'Success',
        isEditMode
          ? 'Announcement updated successfully'
          : formData.publish_status === 'published'
            ? 'Announcement published and email sent'
            : 'Announcement saved as draft',
        'success'
      );

      resetForm();
      fetchAnnouncements();
    } catch (error) {
      Swal.fire('Error', getErrorMessage(error), 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (announcement) => {
    const confirm = await Swal.fire({
      title: 'Are you sure?',
      text: 'Announcement will be deleted.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete'
    });

    if (!confirm.isConfirmed) return;

    try {
      await deleteAnnouncement(getAnnouncementId(announcement));
      Swal.fire('Deleted', 'Announcement deleted successfully', 'success');
      fetchAnnouncements();
    } catch (error) {
      Swal.fire('Error', getErrorMessage(error), 'error');
    }
  };

  const getStatusBadge = (status) => {
    if (status === 'published') return 'bg-success';
    if (status === 'draft') return 'bg-secondary';
    if (status === 'archived') return 'bg-dark';

    return 'bg-light text-dark';
  };

  const getAttachments = (item) => {
    // The backend may name the attachments field several different ways,
    // so check every likely key.
    let list =
      item?.attachments ??
      item?.files ??
      item?.attachment ??
      item?.file ??
      item?.attachment_url ??
      item?.attachment_urls ??
      item?.attachment_path ??
      item?.file_url ??
      item?.file_path ??
      item?.documents ??
      item?.document ??
      item?.images ??
      item?.image ??
      item?.image_url ??
      item?.media ??
      [];

    // A JSON string ("[...]" / "{...}") -> parse. A plain/comma path -> split.
    if (typeof list === 'string') {
      const trimmed = list.trim();
      if (trimmed === '') {
        list = [];
      } else if (trimmed.startsWith('[') || trimmed.startsWith('{')) {
        try {
          list = JSON.parse(trimmed);
        } catch {
          list = [trimmed];
        }
      } else {
        list = trimmed.split(',').map((part) => part.trim()).filter(Boolean);
      }
    }

    // A single attachment object -> wrap into an array.
    if (list && !Array.isArray(list)) list = [list];
    if (!Array.isArray(list)) return [];

    return list
      .map((attachment) => {
        const path =
          attachment?.file_url ||
          attachment?.url ||
          attachment?.file_path ||
          attachment?.path ||
          attachment?.image_url ||
          attachment?.image ||
          attachment;

        if (!path || typeof path !== 'string') return null;

        const name =
          attachment?.file_name ||
          attachment?.name ||
          String(path).split('/').pop();

        const url = /^https?:\/\//i.test(path)
          ? path
          : `${Constants.ROOT_URL}/${String(path).replace(/^\/+/, '')}`;

        return { id: attachment?.id ?? null, name, url };
      })
      .filter(Boolean);
  };

  const filteredAnnouncements = announcements.filter((item) => {
    const keyword = search.toLowerCase();

    const title = getAnnouncementTitle(item);
    const message = getAnnouncementMessage(item);

    const audience = Array.isArray(item.target_audience)
      ? item.target_audience.join(' ')
      : String(item.target_audience || item.audience || '');

    return (
      String(title).toLowerCase().includes(keyword) ||
      String(message).toLowerCase().includes(keyword) ||
      audience.toLowerCase().includes(keyword)
    );
  });

  const totalPages = Math.max(1, Math.ceil(filteredAnnouncements.length / PAGE_SIZE));
  const paginatedAnnouncements = filteredAnnouncements.slice(
    (page - 1) * PAGE_SIZE,
    page * PAGE_SIZE
  );

  useEffect(() => {
    setPage(1);
  }, [search]);

  useEffect(() => {
    if (page > totalPages) setPage(totalPages);
  }, [page, totalPages]);

  return (
    <div className="container-fluid mt-3">
      <style>{`
        /* At normal button font-size, "Preview Announcement" (and the
           longer "Preview Updated Announcement" edit-mode label) doesn't
           fit the card's narrower mobile width and wraps mid-word,
           leaving the icon stranded above a lone second line. */
        @media (max-width: 576px) {
          .ann-preview-btn {
            font-size: 12.5px;
            padding: 8px 10px;
          }
        }
      `}</style>

      <div className="lib-page-header">
        <div className="lib-page-header__left">
          <div className="lib-page-header__icon"><i className="fas fa-bullhorn" /></div>
          <div>
            <h3 className="lib-page-header__title">Announcements</h3>
            <div className="lib-page-header__subtitle" title="General notices published by library staff for a selected audience.">
              General notices published by library staff for a selected audience, such as holidays, timing changes, events, new arrivals or policy updates. For personal activity alerts, see Notifications.
            </div>
          </div>
        </div>
      </div>

      <div className="row g-3">
        <div className="col-lg-6" ref={formSectionRef}>
          <div className="card shadow-sm h-100 table-full-card">
            <div className="card-header fw-bold d-flex justify-content-between align-items-center">
              <span>
                <i className="fas fa-bullhorn me-2" />
                {isEditMode ? 'Edit Announcement Section' : 'Create Announcement'}
              </span>

              {isEditMode && (
                <button
                  type="button"
                  className="btn btn-sm btn-outline-secondary"
                  onClick={resetForm}
                >
                  <i className="fas fa-times me-1" />
                  Cancel Edit
                </button>
              )}
            </div>

            <div className="card-body">
              {isEditMode && (
                <div className="alert alert-warning d-flex justify-content-between align-items-center mb-3">
                  <div>
                    <strong>Edit Mode Active</strong>
                    <div className="small">
                      You are editing an existing announcement. Update details
                      and preview before saving.
                    </div>
                  </div>

                  <button
                    type="button"
                    className="btn btn-sm btn-outline-dark"
                    onClick={resetForm}
                  >
                    Cancel Edit
                  </button>
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label">Title *</label>
                  <input
                    type="text"
                    name="title"
                    className="form-control"
                    value={formData.title}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="row">
                  <div className="col-12 mb-3 col-sm-12">
                    <label className="form-label">Status</label>
                    <SearchableSelect
                      name="publish_status"
                      value={formData.publish_status}
                      onChange={handleChange}
                      options={[
                        { value: 'published', label: 'Published' },
                        { value: 'draft', label: 'Draft' },
                        { value: 'archived', label: 'Archived' }
                      ]}
                      clearable={false}
                    />
                  </div>

                  <div className="col-12 mb-3 col-sm-12">
                    <label className="form-label">Publish Date</label>
                    <input
                      type="date"
                      name="publish_date"
                      className="form-control"
                      value={formData.publish_date}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label">Target Audience *</label>

                  <div
                    className="d-flex flex-wrap gap-3 p-2"
                    style={{
                      border: '1px solid #e2e8f0',
                      borderRadius: 8
                    }}
                  >
                    {AUDIENCE_OPTIONS.map((option) => (
                      <div className="form-check" key={option.value}>
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id={`aud-${option.value}`}
                          checked={(formData.target_audience || []).includes(option.value)}
                          onChange={() => toggleAudience(option.value)}
                        />

                        <label
                          className="form-check-label"
                          htmlFor={`aud-${option.value}`}
                        >
                          {option.label}
                        </label>
                      </div>
                    ))}
                  </div>

                  <small className="text-muted">
                    Message is sent only to the selected audience.
                  </small>
                </div>

                <div className="mb-3">
                  <label className="form-label">Message *</label>
                  <textarea
                    name="message"
                    className="form-control"
                    rows="3"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="mb-3">
                    <label className="form-label">
                      Attachments{' '}
                      <small className="text-muted">
                        (PDF, Word, Excel, images — up to {MAX_FILE_MB} MB each)
                      </small>
                    </label>

                    <div
                      className="p-3 text-center"
                      style={{
                        border: '2px dashed #cbd5e1',
                        borderRadius: 10,
                        background: '#f8fafc'
                      }}
                    >
                      <i className="fas fa-cloud-upload-alt fs-3 text-primary mb-2 d-block" />

                      <input
                        id="ann-file-input"
                        type="file"
                        multiple
                        accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv,.jpg,.jpeg,.png"
                        className="d-none"
                        onChange={handleFilesChange}
                      />

                      <label
                        htmlFor="ann-file-input"
                        className="btn btn-outline-primary btn-sm mb-1"
                      >
                        <i className="fas fa-plus me-1" />
                        Choose Files
                      </label>

                      <div className="small text-muted">
                        You can select multiple files at once
                      </div>
                    </div>

                    {existingAttachments.length > 0 && (
                      <>
                        <div className="small text-muted mt-2 mb-1">
                          <i className="fas fa-paperclip me-1" />
                          Already uploaded ({existingAttachments.length})
                        </div>
                        <ul className="list-group">
                          {existingAttachments.map((file, index) => {
                            const isRemoved = file.id !== null && removedAttachmentIds.includes(file.id);

                            return (
                              <li
                                key={`${file.name}_${index}`}
                                className="list-group-item d-flex justify-content-between align-items-center"
                              >
                                <a
                                  href={file.url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="text-truncate text-decoration-none"
                                  style={{
                                    maxWidth: '80%',
                                    textDecoration: isRemoved ? 'line-through' : undefined,
                                    opacity: isRemoved ? 0.5 : 1
                                  }}
                                  title={file.name}
                                >
                                  <i className={`${fileIcon(file.name)} me-2`} />
                                  {file.name}
                                </a>

                                {file.id !== null && (
                                  <button
                                    type="button"
                                    className={`btn btn-sm ${isRemoved ? 'btn-outline-secondary' : 'btn-outline-danger'}`}
                                    onClick={() => toggleRemoveExistingAttachment(file.id)}
                                  >
                                    {isRemoved ? 'Undo' : <i className="fas fa-times" />}
                                  </button>
                                )}
                              </li>
                            );
                          })}
                        </ul>
                      </>
                    )}

                    {attachments.length > 0 && (
                      <ul className="list-group mt-2">
                        {attachments.map((file, index) => (
                          <li
                            key={`${file.name}_${file.size}_${index}`}
                            className="list-group-item d-flex justify-content-between align-items-center"
                          >
                            <span
                              className="text-truncate"
                              style={{ maxWidth: '80%' }}
                            >
                              <i className={`${fileIcon(file.name)} me-2`} />
                              {file.name}
                              <small className="text-muted ms-2">
                                {formatSize(file.size)}
                              </small>
                            </span>

                            <button
                              type="button"
                              className="btn btn-sm btn-outline-danger"
                              onClick={() => removeAttachment(index)}
                            >
                              <i className="fas fa-times" />
                            </button>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>

                {isEditMode && removedAttachmentIds.length > 0 && (
                  <div className="alert alert-warning small">
                    {removedAttachmentIds.length} attachment{removedAttachmentIds.length > 1 ? 's' : ''} will be removed when you save.
                  </div>
                )}

                <button className="btn btn-primary w-100 ann-preview-btn" disabled={loading}>
                  <i className="fas fa-eye me-1" />
                  {isEditMode ? 'Preview Updated Announcement' : 'Preview Announcement'}
                </button>
              </form>
            </div>
          </div>
        </div>

        <div className="col-lg-6">
          <div className="card shadow-sm h-100 table-full-card">
            <div className="card-header fw-bold">
              <i className="fas fa-list me-2" />
              Announcement List
            </div>

            <div className="card-body">
              <div className="row g-2 align-items-center mb-3">
                <div className="col-7">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search title, message, audience..."
                    value={search}
                    onChange={(event) => setSearch(event.target.value)}
                  />
                </div>

                <div className="col-5">
                  <button
                    type="button"
                    className="btn btn-outline-secondary w-100"
                    onClick={() => setSearch('')}
                  >
                    Reset
                  </button>
                </div>
              </div>

              <div className="table-responsive">
                <table className="table table-bordered table-hover align-middle">
                  <thead className="table-light">
                    <tr>
                      <th style={{ width: 40 }}>#</th>
                      <th>Title / Message</th>
                      <th>Audience</th>
                      <th className="text-center">Status</th>
                      <th className="text-center">Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {paginatedAnnouncements.length > 0 ? (
                      paginatedAnnouncements.map((item, index) => {
                        const files = getAttachments(item);
                        const itemId = getAnnouncementId(item);
                        const isSelected =
                          String(editingId) === String(itemId);

                        return (
                          <tr
                            key={itemId || index}
                            className={isSelected ? 'table-warning' : ''}
                          >
                            <td>{(page - 1) * PAGE_SIZE + index + 1}</td>

                            <td>
                              <div className="fw-bold">
                                {getAnnouncementTitle(item) || '-'}
                              </div>

                              <div
                                className="small text-muted text-truncate"
                                style={{ maxWidth: 220 }}
                              >
                                {getAnnouncementMessage(item) || '-'}
                              </div>

                              {files.length > 0 && (
                                <div className="d-flex flex-column gap-1 mt-1">
                                  {files.map((file, fileIndex) => (
                                    <a
                                      key={fileIndex}
                                      href={file.url}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="text-decoration-none small"
                                      title={file.name}
                                    >
                                      <i className={`${fileIcon(file.name)} me-1`} />
                                      {file.name.length > 16
                                        ? `${file.name.slice(0, 13)}...`
                                        : file.name}
                                    </a>
                                  ))}
                                </div>
                              )}
                            </td>

                            <td>
                              <div className="small">
                                {audienceLabel(item.target_audience || item.audience)}
                              </div>

                              <div className="small text-muted">
                                {getAnnouncementDate(item)}
                              </div>
                            </td>

                            <td className="text-center">
                              <span
                                className={`badge ${getStatusBadge(
                                  getAnnouncementStatus(item)
                                )}`}
                              >
                                {getAnnouncementStatus(item)}
                              </span>
                            </td>

                            <td className="text-center">
                              <button
                                type="button"
                                className="btn btn-sm btn-outline-primary me-1"
                                onClick={() => handleEdit(item)}
                                title="Edit"
                              >
                                <i className="fas fa-pen" />
                              </button>

                              <button
                                type="button"
                                className="btn btn-sm btn-outline-danger"
                                onClick={() => handleDelete(item)}
                                title="Delete"
                              >
                                <i className="fas fa-trash" />
                              </button>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td
                          colSpan="5"
                          className="text-center text-muted py-4"
                        >
                          No announcements found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>

                <Pagination
                  page={page}
                  totalPages={totalPages}
                  totalItems={filteredAnnouncements.length}
                  itemLabel="announcements"
                  onPageChange={setPage}
                />
              </div>

              {loading && (
                <Loader compact label="Loading..." size="sm" />
              )}
            </div>
          </div>
        </div>
      </div>

      {showPreview && (
        <div
          className="ann-modal-overlay"
          onClick={(event) =>
            event.target === event.currentTarget && closePreview()
          }
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(15,23,42,.55)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1060,
            padding: 16
          }}
        >
          <div
            style={{
              background: '#fff',
              borderRadius: 14,
              width: '100%',
              maxWidth: 640,
              maxHeight: '92vh',
              overflow: 'auto',
              boxShadow: '0 20px 50px rgba(2,28,55,.35)',
              fontFamily: 'Segoe UI, Roboto, Arial, sans-serif'
            }}
          >
            <div
              className="d-flex justify-content-between align-items-center px-4 py-2"
              style={{
                background: '#f6f8fc',
                borderBottom: '1px solid #e3e8ef'
              }}
            >
              <div
                className="d-flex align-items-center gap-2"
                style={{ color: '#5f6368' }}
              >
                <i className="fas fa-inbox" />
                <span style={{ fontSize: 13, fontWeight: 600 }}>
                  Email Preview
                </span>
              </div>

              <div
                className="d-flex align-items-center gap-3"
                style={{ color: '#5f6368' }}
              >
                <button
                  type="button"
                  className="btn btn-sm"
                  onClick={() => setPreviewEdit((prev) => !prev)}
                  style={{
                    background: previewEdit ? '#1a73e8' : 'transparent',
                    color: previewEdit ? '#fff' : '#1a73e8',
                    border: '1px solid #1a73e8',
                    fontSize: 12,
                    padding: '3px 12px',
                    borderRadius: 16
                  }}
                >
                  <i className={`fas ${previewEdit ? 'fa-check' : 'fa-pen'} me-1`} />
                  {previewEdit ? 'Done' : 'Edit'}
                </button>

                <i
                  className="fas fa-times"
                  role="button"
                  onClick={closePreview}
                  title="Close"
                />
              </div>
            </div>

            <div
              className="px-4 pt-3 pb-2"
              style={{ borderBottom: '1px solid #f1f3f4' }}
            >
              {previewEdit ? (
                <input
                  type="text"
                  name="title"
                  value={formData.title}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Subject"
                  style={{
                    fontSize: 20,
                    fontWeight: 600,
                    border: '1px dashed #1a73e8'
                  }}
                />
              ) : (
                <h4
                  className="mb-0"
                  style={{ color: '#202124', fontWeight: 500 }}
                >
                  {formData.title || '(no subject)'}
                </h4>
              )}

              <div className="d-flex align-items-center gap-2 mt-2 flex-wrap">
                <span
                  style={{
                    fontSize: 11,
                    fontWeight: 700,
                    padding: '2px 10px',
                    borderRadius: 12,
                    textTransform: 'capitalize',
                    background:
                      formData.publish_status === 'published'
                        ? '#e6f4ea'
                        : formData.publish_status === 'draft'
                          ? '#f1f3f4'
                          : '#e8eaed',
                    color:
                      formData.publish_status === 'published'
                        ? '#137333'
                        : formData.publish_status === 'draft'
                          ? '#5f6368'
                          : '#3c4043'
                  }}
                >
                  <i
                    className={`fas ${
                      formData.publish_status === 'published'
                        ? 'fa-paper-plane'
                        : 'fa-file-alt'
                    } me-1`}
                  />
                  {formData.publish_status}
                </span>

                {audienceList(formData.target_audience).map((audience) => (
                  <span
                    key={audience}
                    style={{
                      fontSize: 11,
                      fontWeight: 700,
                      padding: '2px 10px',
                      borderRadius: 12,
                      background: audienceColor(audience).bg,
                      color: audienceColor(audience).fg
                    }}
                  >
                    {oneAudienceLabel(String(audience).toLowerCase())}
                  </span>
                ))}
              </div>
            </div>

            <div className="d-flex align-items-center gap-3 px-4 py-3">
              <div
                style={{
                  width: 42,
                  height: 42,
                  borderRadius: '50%',
                  flexShrink: 0,
                  background: 'linear-gradient(135deg,#4f46e5,#2563eb)',
                  color: '#fff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: 18,
                  fontWeight: 700
                }}
              >
                CL
              </div>

              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 14, color: '#202124' }}>
                  <strong>Community Library</strong>{' '}
                  <span style={{ color: '#5f6368', fontSize: 13 }}>
                    &lt;no-reply@library.com&gt;
                  </span>
                </div>

                <div style={{ fontSize: 12.5, color: '#5f6368' }}>
                  to <strong>{audienceLabel(formData.target_audience)}</strong>
                </div>
              </div>

              <div
                style={{
                  fontSize: 12.5,
                  color: '#5f6368',
                  whiteSpace: 'nowrap'
                }}
              >
                {formData.publish_date || '-'}
              </div>
            </div>

            <div className="px-4 pb-3" style={{ color: '#202124' }}>
              {previewEdit ? (
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  className="form-control"
                  rows="6"
                  placeholder="Message body"
                  style={{
                    fontSize: 14.5,
                    border: '1px dashed #1a73e8'
                  }}
                />
              ) : (
                <div
                  style={{
                    fontSize: 14.5,
                    lineHeight: 1.8,
                    whiteSpace: 'pre-wrap'
                  }}
                >
                  {formData.message}
                </div>
              )}

              {attachments.length > 0 && (
                <div style={{ marginTop: 20 }}>
                  <div
                    style={{
                      fontSize: 13,
                      color: '#5f6368',
                      marginBottom: 8
                    }}
                  >
                    <i className="fas fa-paperclip me-1" />
                    {attachments.length} Attachment
                    {attachments.length > 1 ? 's' : ''}
                  </div>

                  <div className="d-flex flex-wrap gap-2">
                    {attachments.map((file, index) => (
                      <div
                        key={`${file.name}_${index}`}
                        style={{
                          width: 150,
                          border: '1px solid #dadce0',
                          borderRadius: 8,
                          fontSize: 13,
                          background: '#f8f9fa',
                          overflow: 'hidden'
                        }}
                      >
                        {isImage(file.name) && attachmentUrls[index] ? (
                          <a
                            href={attachmentUrls[index]}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src={attachmentUrls[index]}
                              alt={file.name}
                              style={{
                                width: '100%',
                                height: 100,
                                objectFit: 'cover',
                                display: 'block'
                              }}
                            />
                          </a>
                        ) : (
                          <div
                            style={{
                              height: 100,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              background: '#eef1f5'
                            }}
                          >
                            <i
                              className={fileIcon(file.name)}
                              style={{ fontSize: 34 }}
                            />
                          </div>
                        )}

                        <div style={{ padding: '6px 8px' }}>
                          <div
                            style={{
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap'
                            }}
                          >
                            {file.name}
                          </div>

                          <div style={{ color: '#94a3b8', fontSize: 11 }}>
                            {formatSize(file.size)}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {existingAttachments.filter((file) => file.id === null || !removedAttachmentIds.includes(file.id)).length > 0 && (
                <div style={{ marginTop: 20 }}>
                  <div
                    style={{
                      fontSize: 13,
                      color: '#5f6368',
                      marginBottom: 8
                    }}
                  >
                    <i className="fas fa-paperclip me-1" />
                    {existingAttachments.filter((file) => file.id === null || !removedAttachmentIds.includes(file.id)).length} Already uploaded
                  </div>

                  <div className="d-flex flex-wrap gap-2">
                    {existingAttachments
                      .filter((file) => file.id === null || !removedAttachmentIds.includes(file.id))
                      .map((file, index) => (
                      <div
                        key={`${file.name}_${index}`}
                        style={{
                          width: 150,
                          border: '1px solid #dadce0',
                          borderRadius: 8,
                          fontSize: 13,
                          background: '#f8f9fa',
                          overflow: 'hidden'
                        }}
                      >
                        {isImage(file.name) ? (
                          <a
                            href={file.url}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src={file.url}
                              alt={file.name}
                              style={{
                                width: '100%',
                                height: 100,
                                objectFit: 'cover',
                                display: 'block'
                              }}
                            />
                          </a>
                        ) : (
                          <a
                            href={file.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              height: 100,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              background: '#eef1f5'
                            }}
                          >
                            <i
                              className={fileIcon(file.name)}
                              style={{ fontSize: 34 }}
                            />
                          </a>
                        )}

                        <div style={{ padding: '6px 8px' }}>
                          <div
                            style={{
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap'
                            }}
                          >
                            {file.name}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              <div
                style={{
                  marginTop: 22,
                  paddingTop: 14,
                  borderTop: '1px solid #f1f3f4',
                  fontSize: 12,
                  color: '#94a3b8'
                }}
              >
                This is an automated message from your Community Library.
              </div>
            </div>

            <div
              className="d-flex justify-content-between align-items-center px-4 py-3"
              style={{
                borderTop: '1px solid #e3e8ef',
                background: '#f6f8fc'
              }}
            >
              <small className="text-muted">
                {formData.publish_status === 'published'
                  ? 'This email will be sent to the selected audience'
                  : 'Saved as draft — no email will be sent'}
              </small>

              <div className="d-flex gap-2">
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={closePreview}
                  disabled={loading}
                >
                  Back to Form
                </button>

                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleConfirmSave}
                  disabled={loading}
                >
                  {loading
                    ? 'Saving...'
                    : isEditMode
                      ? 'Update Announcement'
                      : formData.publish_status === 'published'
                        ? 'Publish & Send'
                        : 'Save as Draft'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AnnouncementList;